import { useEffect, useState } from "react";

export function useShowLoader() {
    const [show, setShow] = useState();

    useEffect(() => {
        function handler() {
            setShow(prev => !prev);
        }
        setTimeout(handler, 100);
        return () => clearTimeout(handler);
    }, []);

    return show;
}